const useGetProjectListDto = async (
  variables?: GetProjectListQueryVariables,
  options?: GraphqlQueryOptions<GetProjectListQuery, GetProjectListQueryVariables>,
) => {
  const query = await useGraphqlQuery(GetProjectListSchema, variables, options);
  const list = computed(() => query.result.value?.content?.projects?.list ?? null);
  const meta = computed(() => query.result.value?.content?.projects?.meta ?? null);

  return {
    ...query,
    list,
    meta,
  };
};

export { useGetProjectListDto };
